import React, { useState } from "react";
import { Link } from "react-router-dom";

const CountryMaster = () => {
  const [countries, setCountries] = useState([
    { id: 1, name: "India", code: "IN", status: "Active" },
    { id: 2, name: "United States", code: "US", status: "Active" },
    { id: 3, name: "Germany", code: "DE", status: "Inactive" },
  ]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Country Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Master</a>
                </li>
                <li className="breadcrumb-item active">Country List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4 className="card-title">All Countries</h4>
                <Link to="/country-add">
                  <button className="btn btn-primary btn-sm">+ Add Country</button>
                </Link>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Country Name</th>
                        <th>Country Code</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {countries.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.code}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                           <td>
                            <div className="d-flex gap-2">
                              <a href="#!" className="btn btn-light btn-sm">
                                <i className="fa-solid fa-eye fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {countries.length === 0 && (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Countries Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer text-end">
                <small className="text-muted">Total Countries: {countries.length}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryMaster;
